import { FunctionComponent } from 'react';
import { Banner } from './banner';
import { ContentPageVariant } from '@pnpmworkspace/shared-types';
import { ContentPageSectionVisibility } from '@/services/configurator/PlannerConfigTypes';

type AppointmentProps = {
  appointment1: {
    title: string;
    description: string;
    bookButton: string;
    bookUrl: string;
  };
  appointment2: {
    title: string;
    description: string;
    bookButton: string;
    bookUrl: string;
  };
  contentPageVariant?: ContentPageVariant;
  dynamicView?: ContentPageSectionVisibility;
};

export const Appointment: FunctionComponent<AppointmentProps> = ({
  appointment1,
  appointment2,
  contentPageVariant,
  dynamicView,
}) => {
  const hasAppointmentData =
    appointment1.title &&
    appointment1.description &&
    appointment1.bookButton &&
    appointment1.bookUrl;

  const hasAppointment2Data =
    appointment2.title &&
    appointment2.description &&
    appointment2.bookButton &&
    appointment2.bookUrl;
  return (
    <div className='plann-content-page-row flex flex-wrap gap-8 w-full'>
      {hasAppointmentData && dynamicView && dynamicView.pagePrimaryCard && (
        <Banner
          title={appointment1.title}
          description={appointment1.description}
          cta={appointment1.bookButton}
          linkTo={appointment1.bookUrl}
          componentType='learn_more_banner'
          contentPageVariant={contentPageVariant}
        />
      )}
      {hasAppointment2Data && dynamicView && dynamicView.pageSecondaryCard && (
        <Banner
          title={appointment2.title}
          description={appointment2.description}
          cta={appointment2.bookButton}
          linkTo={appointment2.bookUrl}
          componentType='discover_now_banner'
          contentPageVariant={contentPageVariant}
        />
      )}
    </div>
  );
};
